/**
 * Определяет значения возможных направлений навигации внутри формы
 * В направлении следующего шага, предыдущего и при навигации к конкретному шагу
 *  */
export var ENavigationDirections;
(function (ENavigationDirections) {
  ENavigationDirections["Backward"] = "backward";
  ENavigationDirections["Forward"] = "forward";
  ENavigationDirections["Direct"] = "direct";
})(ENavigationDirections || (ENavigationDirections = {}));